module.exports = __webpack_public_path__ + "static/media/depot-mobile.2d7922ef.jpeg";